import { render, staticRenderFns } from "./LayoutPopup.vue?vue&type=template&id=5a143978&scoped=true"
import script from "./LayoutPopup.vue?vue&type=script&lang=js"
export * from "./LayoutPopup.vue?vue&type=script&lang=js"
import style0 from "./LayoutPopup.vue?vue&type=style&index=0&id=5a143978&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a143978",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDivider})
